﻿import './Coupons.scss';
import '../Shared/Coupon/Coupon.scss';
import '../Coupons/CouponSignUpForm/CouponSignUpForm';
import $ from 'jquery';


$( document ).ready(function() {

    let visibleCoupons = {};
    let filters = '.custom-select ul li';
    let coupons = '.coupons-list .coupon-wrap';


    function showSelectedCoupons( dataId ) {
        let selectedCoupons = [];

        $(coupons).each(function (idx, coupon) {
            let categoryString = $(coupon).data('category') + '';

            let match = $.inArray(dataId + '', categoryString.split(','));

            if(match > -1 || dataId === 0){
                selectedCoupons.push(coupon);
            }
        });


        selectedCoupons.forEach(function (coupon, idx) {
            if(idx < visibleCoupons[dataId] ||  window.innerWidth > 767){
                $(coupon).removeClass('hidden');
            }
        });

        if((selectedCoupons.length > visibleCoupons[dataId]) && window.innerWidth < 768){
            $('.js-add-more').show();
        } else {
            $('.js-add-more').hide();
        }

    }

    //oopen menu
    $('.custom-selected').click(function (event) {
        event.stopPropagation();
        $(this).toggleClass('open');
    });

    $(window).click(function () {
        $('.custom-selected').removeClass('open');
    });

    //print
    $('#print-coupon').click(function (e) {
        e.preventDefault();

        //if (window.screen.availWidth > 767) {
        //    window.print();
        //}

        window.print();
    });


    //filter services
    $(filters).click(function () {
        let dataId = $(this).data("id");

        $(filters).removeClass('selected');
        $(this).addClass('selected');

        $(coupons).each(function (idx, coupon) {
            $(coupon).addClass('hidden');
        });

        showSelectedCoupons(dataId);

        $('.custom-selected').removeClass('open').text($(this).text());
    });

    //add more btn
    $('.js-add-more').click(function () {
        let dataId = $(filters + ".selected").data("id");

        visibleCoupons[dataId] += 2;

        showSelectedCoupons(dataId);
    });

    //set for each filter visibleCoupons
    $(filters).each(function (idx, filter) {
        let dataId = $(filter).data('id');
        visibleCoupons[dataId] = 4;
    });

    $( window ).resize(function() {
        $(filters + ".selected").click();
    });

    $(window).trigger('resize');
});



// WEBPACK FOOTER //
// ./Src/Coupons/Coupons.js